import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";

/* Layout */
import Layout from "@/layout/index.vue";
import Layout2 from "@/layout/2.vue";

export const constantRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/login.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/register/register.vue"),
  },
  // 扫码注册跳转页面（用于安全传递邀请码，不暴露在 URL 中）
  {
    path: "/qr-register",
    name: "QRRegister",
    component: () => import("@/views/register/qr_redirect.vue"),
  },
    {
    path: "/recover_pwd",
    name: "recoverPwd",
    component: () => import("@/views/login/recover_pwd.vue"),
  },
  {
    path: "/error",
    name: "Error",
    component: Layout,
    meta: {
      title: "错误页",
      icon: "error-warning-line",
      levelHidden: true,
    },
    children: [
      {
        path: "403",
        name: "Error403",
        component: () => import("@/views/403.vue"),
        meta: {
          title: "403",
          icon: "error-warning-line",
        },
      },
      {
        path: "404",
        name: "Error404",
        component: () => import("@/views/404.vue"),
        meta: {
          title: "404",
          icon: "error-warning-line",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/error/404",
    name: "NotFound",
    meta: {
      hidden: true,
    },
  },
];

export const asyncRoutes = [
  {
    path: "/",
    redirect: "index",
    component: Layout,
    //component: () => import("@/views/Main.vue"),
    meta: {
      title: "首页",
      icon: "",
    },
    children: [
      {
        path: "index",
        name: "首页",
        m_id: "010000",
        component: () => import("@/views/home/index.vue"),
        meta: {
          title: "首页",
          icon: "",
          hideclose: true,
        },
      },
      {
        path: "detail",
        name: "详情",
        m_id: "010000",
        component: () => import("@/views/home/detail.vue"),
        meta: {
          title: "详情",
          icon: "",
          hideclose: true,
        },
      },
      {
        path: "introduce",
        name: "平台介绍",
        m_id: "010000",
        component: () => import("@/views/home/introduce.vue"),
        meta: {
          title: "平台介绍",
          icon: "",
          hideclose: true,
        },
      },
      {
        path: "download",
        name: "产品下载",
        m_id: "020000",
        component: () => import("@/views/home/download.vue"),
        meta: {
          title: "版本介绍",
          icon: "",
          hideclose: true,
        },
      },
      {
        path: "my_center",
        name: "个人中心",
        m_id: "020000",
        component: () => import("@/views/home/my_center.vue"),
        meta: {
          title: "个人中心",
          icon: "",
          hideclose: true,
        },
      },
      {
        path: "risk",
        name: "风险提示",
        m_id: "090000",
        component: () => import("@/views/home/risk.vue"),
        meta: {
          title: "风险提示",
          icon: "",
          hideclose: true,
        },
      },
      {
        path: "privacy",
        name: "隐私条款",
        m_id: "090000",
        component: () => import("@/views/home/privacy.vue"),
        meta: {
          title: "隐私条款",
          icon: "",
          hideclose: true,
        },
      },
      {
        path: "disclaimer",
        name: "免责条款",
        m_id: "090000",
        component: () => import("@/views/home/disclaimer.vue"),
        meta: {
          title: "免责条款",
          icon: "",
          hideclose: true,
        },
      },
    ],
  },
];

export const asyncRoutesLimt = JSON.parse(JSON.stringify(asyncRoutes));

sessionStorage.setItem("asyncRoutes", asyncRoutes);

// 开发以及部署时的URL
// hash模式时在不确定二级目录名称的情况下建议使用""代表相对路径或者"/二级目录/"
// history模式默认使用"/"或者"/二级目录/"，记住只有hash时publicPath可以为空！！！
const publicPath = "/";
// intelligence(前端导出路由)和all(后端导出路由)两种方式
const authentication = "intelligence";
// 缓存路由的最大数量
const keepAliveMaxNum = 20;
// 路由模式，是否为hash模式
const isHashRouterMode = true;

const router = createRouter({
  history: isHashRouterMode
    ? createWebHashHistory(publicPath)
    : createWebHistory(publicPath),
  routes: constantRoutes,
});

function fatteningRoutes(routes) {
  return routes.flatMap((route) => {
    return route.children ? fatteningRoutes(route.children) : route;
  });
}

function addRouter(routes) {
  routes.forEach((route) => {
    if (!router.hasRoute(route.name)) router.addRoute(route);
    // console.log("====route=====1========");
    // console.log(route);
    // console.log(route.m_id);
    // console.log(route.name);
    // console.log("====route=====2========");
    if (route.children) addRouter(route.children);
  });
}

export function resetRouter(routes = constantRoutes) {
  routes.map((route) => {
    if (route.children) {
      route.children = fatteningRoutes(route.children);
    }
  });
  router.getRoutes().forEach((route) => {
    const routeName = route.name;
    router.hasRoute(routeName) && router.removeRoute(routeName);
  });
  addRouter(routes);
}

// 遍历数组,查看权限
export function menu_limits(menu_limit, asyncRoutes_list) {
  console.log(asyncRoutes_list);
  
  return asyncRoutes_list
}

export function setupRouter(app) {
  // alert(sessionStorage.getItem("limit_menu"));
  var asyncRoutes_list = asyncRoutes;
  // var asyncRoutes_list = JSON.parse(JSON.stringify(asyncRoutes));
  // var asyncRoutes_list2 ;
  // var asyncRoutes_list = Object.assign(asyncRoutes);
  // var asyncRoutes_list = sessionStorage.getItem("asyncRoutes");
  try {
    asyncRoutes_list = menu_limits(sessionStorage.getItem("limit_menu"), asyncRoutes_list);
  } catch (e) {
    console.log(e)
  }
  if (authentication === "intelligence") addRouter(asyncRoutes_list);
  try {
    app.use(router);
  } catch (e) {
    console.log(e)
  }
  
  return router;
}

export default router;
